// src/components/store/sections/gallery/GalleryV75BentomosaicEmeraldMint.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV75BentomosaicEmeraldMint(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={75}
      archKey="bento_mosaic"
      archLabel="Bento Mosaic Lookbook"
      palName="EmeraldMint"
      grad="from-emerald-500 via-teal-500 to-emerald-700"
      lightBg="bg-emerald-50"
      textCol="text-emerald-700"
      borderCol="border-emerald-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#10b981"
      {...props}
    />
  );
}
